<template>
    <div class="flex flex-col mt-2 overflow-x-scroll">
        <div v-if="! showFilter" class="w-full flex justify-end text-sm font-semibold mb-2 text-blue-800">
            <a href="#" @click.prevent="showFilter = true" class="flex items-center">
                <svg class="w-5 h-5 mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path></svg>
                <span>Search and Filter</span>
            </a>
        </div>
        <div v-if="showFilter" class="flex p-4 py-8 rounded-lg bg-blue-50 mb-8 relative">
            <svg @click="showFilter = false" class="h-5 h-5 absolute top-0 right-0 mr-2 text-blue-800 mt-2 cursor-pointer" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            <div class="w-1/4 pr-4">
                <div class="mt-1 relative rounded-md shadow-sm">
                    <label class="text-xs text-gray-500 pl-1">Min Invoice No</label>
                    <input v-model="searchOptions.minInvoiceNum" type="text" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full p-3 font-mono border-gray-300 rounded-md">
                </div>
            </div>
            <div class="w-1/4 pr-4">
                <div class="mt-1 relative rounded-md shadow-sm">
                    <label class="text-xs text-gray-500 pl-1">Max Invoice No</label>
                    <input v-model="searchOptions.maxInvoiceNum" type="text" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full p-3 font-mono border-gray-300 rounded-md">
                </div>
            </div>
            <div class="w-1/4 pr-4">
                <div class="mt-1 relative rounded-md shadow-sm">
                    <label class="text-xs text-gray-500 pl-1">Min Ship Date</label>
                    <input v-model="searchOptions.minShipDate" type="date" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full p-3 font-mono border-gray-300 rounded-md">
                </div>
            </div>
            <div class="w-1/4 pr-4">
                <div class="mt-1 relative rounded-md shadow-sm">
                    <label class="text-xs text-gray-500 pl-1">Max Ship Date</label>
                    <input v-model="searchOptions.maxShipDate" type="date" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full p-3 font-mono border-gray-300 rounded-md">
                </div>
            </div>
        </div>
        <div class="-my-2 sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow border-b border-gray-200 sm:rounded-lg">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-50">
                        <tr>
                            <table-head display="Invoice Number" key-name="invoice_number" :sort-key="sortKey" :sort-order="sortOrder" />
                            <table-head display="Load Number" key-name="contract_load_number" :sort-key="sortKey" :sort-order="sortOrder"  />
                            <table-head display="Ship Date" key-name="ticket_date" :sort-key="sortKey" :sort-order="sortOrder"  />
                            <table-head display="Shipper Name" key-name="shipper_name" :sort-key="sortKey" :sort-order="sortOrder"  />
                            <table-head display="Ship Destination" key-name="ship_to_name" :sort-key="sortKey" :sort-order="sortOrder"  />
                            <table-head display="Railcar ID" key-name="car_id_number" :sort-key="sortKey" :sort-order="sortOrder"  />
                            <table-head display="Product Code" key-name="product_code" :sort-key="sortKey" :sort-order="sortOrder"  />
                            <table-head display="Qty (lbs)" key-name="units_before_conversion" :sort-key="sortKey" :sort-order="sortOrder"  />
                            <table-head display="Unit Price" key-name="unit_charge_price" :sort-key="sortKey" :sort-order="sortOrder"  />
                            <table-head display="Invoice Amount" key-name="invoice_amount" :sort-key="sortKey" :sort-order="sortOrder"  />
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, idx) in sortedItems" class="border-b border-gray-100">
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                <a href="#" @click.prevent="showInvoice(item)" class="text-blue-800">{{ item.invoice_number }}</a>
                            </td>
                            <td class="px-6 py-4 text-gray-800 text-sm">
                                {{ item.contract_load_number }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
                                {{ item.ticket_date | niceDate }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
                                {{ item.shipper_name }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
                                {{ item.ship_to_name}}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
                                {{ item.car_id_number }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
                                {{ item.product_code}}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
                                {{ item.units_before_conversion | numberInThousands }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
                                {{ item.unit_charge_price | currency }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
                                {{ total(item) | currency }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div v-if="items.length === 0" class="text-center text-gray-400 text-lg p-8">No current items...</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import TableHead from "@/Components/DataTable/TableHead";

export default {
    components: {TableHead},
    props: {
        items: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            filteredItems: [],
            showFilter: false,
            sortKey: 'invoice_number',
            sortOrder: 'desc',
            searchOptions: {},
        }
    },
    mounted() {
        this.filteredItems = this.items
        this.$eventBus.$on('sortBy', (keyName) => {
            console.log('sort' + keyName)
            this.sortBy(keyName)
        })
    },
    methods: {
        showInvoice(item) {
            this.$eventBus.$emit('show-contract-invoice', item)
        },
        convertedUnits(item) {
            //  0 = PER TON
            //  1 = PER POUND
            //  2 = PER ITEM

            // convert to tons if needed
            if (item.invoice_pricing?.price_type === 0) {
                return item.units_before_conversion / 2000
            }

            return item.units_before_conversion

        },
        total(item) {
            return this.convertedUnits(item) * item.unit_charge_price
        },
        sortBy(key) {
            this.sortKey = key
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        },
        compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
                const comparison = a[key].toString().localeCompare(b[key], undefined, {numeric: true});
                return (
                    (order === 'desc') ? (comparison * -1) : comparison
                );
            };
        }
    },
    computed: {
        sortedItems() {
            return this.filteredItems.sort(
                this.compareValues(this.sortKey, this.sortOrder)
            )
        }
    },
    watch: {
        searchOptions: {
            deep: true,
            handler() {
                this.filteredItems = this.items
                if (this.searchOptions.minInvoiceNum) {
                    this.filteredItems = this.filteredItems.filter(item => item.invoice_number >= parseInt(this.searchOptions.minInvoiceNum))
                }
                if (this.searchOptions.maxInvoiceNum) {
                    this.filteredItems = this.filteredItems.filter(item => item.invoice_number <= parseInt(this.searchOptions.maxInvoiceNum))
                }
                if (this.searchOptions.minInvoiceDate) {
                    this.filteredItems = this.filteredItems.filter(item => new Date(item.ticket_date) >= new Date(this.searchOptions.minInvoiceDate))
                }
                if (this.searchOptions.maxInvoiceDate) {
                    this.filteredItems = this.filteredItems.filter(item => new Date(item.ticket_date) <= new Date(this.searchOptions.maxInvoiceDate))
                }
            }
        }
    }
}
</script>
